import styled from 'styled-components';

export const Container = styled.main`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  width: 100%;
`;
